import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

import FilesModal from "@/components/desktop/files/FilesModal/FilesModal";

const FilesModals = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const [searchParams] = useSearchParams();

	const relatedTable = searchParams.get("file");
	const externalCode = searchParams.get("code");

	if (!relatedTable || !externalCode) {
		return null;
	}

	const handleClose = () => {
		const updatedSearchParams = new URLSearchParams(location.search);
		updatedSearchParams.delete("file");
		updatedSearchParams.delete("code");

		navigate(
			{
				pathname: location.pathname,
				search: updatedSearchParams.toString() ? `?${updatedSearchParams.toString()}` : "",
				hash: location.hash,
			},
			{ replace: true },
		);
	};

	return <FilesModal relatedTable={relatedTable} externalCode={externalCode} onClose={handleClose} />;
};

export default FilesModals;
